// extracted by mini-css-extract-plugin
export default {"divPaginas":"HeaderProdutos_divPaginas__XaTqk","results":"HeaderProdutos_results__+ZNcx","separator":"HeaderProdutos_separator__XB6-J"};